import { render, staticRenderFns } from "./KeywordPieChart.vue?vue&type=template&id=e87f53b4&scoped=true"
import script from "./KeywordPieChart.vue?vue&type=script&lang=js"
export * from "./KeywordPieChart.vue?vue&type=script&lang=js"
import style0 from "./KeywordPieChart.vue?vue&type=style&index=0&id=e87f53b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e87f53b4",
  null
  
)

export default component.exports